import {EntityStore, StoreConfig} from "@datorama/akita";
import {LeagueState} from "./models";

@StoreConfig({name: 'league'})
export class LeagueStore extends EntityStore<LeagueState> {
}